import React from 'react';
import { useReveal } from '../lib/useReveal';
const PRODUCT_IMG = 'https://cdn.magicpatterns.com/uploads/1RrGSPsADtz5ojo4xLqmSN/MOCKUP_BIO.png';
const BENEFITS = ['6 tomos profesionales', '6 recursos prácticos', 'Casos clínicos reales', 'Protocolos de sesión', 'Certificado digital', 'Acceso inmediato'];
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="pt-6 pb-6 md:pt-12 md:pb-10 px-4 sm:px-6 overflow-hidden relative flex flex-col justify-center bg-[#f5efe0]" data-id="element-178">
      <div ref={ref1} className={`reveal container mx-auto max-w-4xl relative z-10 text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-179">
        {/* Badge */}
        <div className="mb-3 md:mb-4" data-id="element-180">
          <span className="text-[#5a6b3f] text-[10px] md:text-xs font-bold tracking-[0.25em] uppercase bg-[#faf3e3] border border-[#2d3f2a]/15 rounded-full px-4 py-1.5 inline-block" data-id="element-181">
            Formación Profesional en Biodecodificación
          </span>
        </div>

        {/* Headline */}
        <h1 className="font-serif font-bold tracking-tight leading-[1.1] text-[#1e3a1e] text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-3 md:mb-4 max-w-3xl mx-auto" data-id="element-182">
          Aprendé Biodescodificación y desarrollá{' '}
          <span className="text-[#b8860b] italic" data-id="element-183">herramientas reales</span>
        </h1>

        {/* Subtitle */}
        <p className="text-[#3a4a35] mb-4 md:mb-5 leading-relaxed text-sm md:text-base max-w-xl mx-auto" data-id="element-184">
          Formación 100% digital con enfoque práctico y profesional, aplicable
          desde la primera sesión.
        </p>

        {/* Mockup — Compact */}
        <div className="flex justify-center mb-3" data-id="element-185">
          <div className="relative animate-float w-full max-w-[280px] sm:max-w-xs md:max-w-sm" data-id="element-186">
            <img src={PRODUCT_IMG} alt="MegaPack Biodescodificación Integral" className="w-full object-contain block drop-shadow-[0_15px_35px_rgba(45,63,42,0.2)]" data-id="element-187" />
          </div>
        </div>

        {/* Rating */}
        <div className="flex items-center justify-center gap-1.5 mb-4 flex-wrap" data-id="element-188">
          <div className="flex gap-0.5 text-[#b8860b] text-sm" data-id="element-189">
            <span data-id="element-190">★</span>
            <span data-id="element-191">★</span>
            <span data-id="element-192">★</span>
            <span data-id="element-193">★</span>
            <span data-id="element-194">★</span>
          </div>
          <span className="text-[#2a1f0f] font-bold text-xs sm:text-sm" data-id="element-195">
            4.9/5
          </span>
          <span className="text-[#5a5040] text-xs sm:text-sm" data-id="element-196">·</span>
          <span className="text-[#5a5040] text-xs sm:text-sm font-medium" data-id="element-197">
            +800 reseñas verificadas
          </span>
        </div>

        {/* CTA */}
        <a href="#premium" className="inline-block w-full sm:w-auto px-8 py-4 rounded-xl text-white font-bold text-sm md:text-base tracking-widest uppercase transition-all shadow-[0_8px_20px_rgba(45,63,42,0.2)] hover:shadow-[0_12px_28px_rgba(45,63,42,0.3)] hover:-translate-y-1 bg-[#2d3f2a] hover:bg-[#1e3a1e] text-center" style={{
        fontFamily: "'Inter', sans-serif"
      }} data-id="element-198">
          Sí, quiero la formación →
        </a>
        <p className="text-[#7a7060] text-xs mt-2 font-medium" data-id="element-199">
          Acceso inmediato luego de la compra.
        </p>

        {/* Benefits — Inline chips below CTA */}
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1.5 mt-5 max-w-2xl mx-auto" data-id="element-200">
          {BENEFITS.map((benefit, i) => <span key={i} className="text-[#2a1f0f] text-[11px] sm:text-xs font-medium inline-flex items-center gap-1" data-id="element-201">
              <span className="text-[#5a6b3f] flex-shrink-0" data-id="element-202">✓</span>
              <span data-id="element-203">{benefit}</span>
            </span>)}
        </div>
      </div>
    </section>;
}